import {
  getCurrentPageFromMeta as getPage,
  getMetaFromPagination as getMeta,
  PaginationProps,
} from "@malond/utils"
import { ResponseEnterpriseGetListMeta } from "../../libs/api/backend/src"

export type { PaginationProps }

export function getCurrentPageFromMeta({
  limit,
  offset,
  total,
}: ResponseEnterpriseGetListMeta): number {
  return getPage({ limit, offset, total })
}

export function getMetaFromPagination(
  page: number,
  pageSize: number
): PaginationProps {
  return getMeta(page, pageSize)
}
